import React from 'react';
import classnames from 'classnames';
// eslint-disable-next-line import/no-extraneous-dependencies
import { from } from 'rxjs';
// eslint-disable-next-line import/no-extraneous-dependencies
import { switchMap } from 'rxjs/operators';

import Loader from '@Components/Loader';
// eslint-disable-next-line import/no-named-as-default
import StructureEditorInstance from '@Containers/StructureEditor/StructureEditorInstance';
import PropTypes from 'prop-types';
import injectScripts from '@Containers/StructureEditor/Chemdraw/injectScripts';
import ChemdrawController from './ChemdrawController';

import './Chemdraw.scss';

export default class Chemdraw extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
    };
    this.ref = React.createRef();
  }

  componentDidMount() {
    // lazy load chemdraw
    this.script$Subscription = from(injectScripts())
      .pipe(
        switchMap(() => {
          const { onChange, onLoaded } = this.props;
          this.instance = new ChemdrawController(this.ref.current);
          this.instance.onChange(onChange);
          this.instance.onLoaded(onLoaded);
          StructureEditorInstance.instance = this.instance;
          return from(this.instance.state);
        })
      )
      .subscribe(() => {
        this.setState({
          loading: false,
        });
      });
  }

  componentWillUnmount() {
    this.script$Subscription.unsubscribe();
    StructureEditorInstance.instance = undefined;
  }

  render() {
    const { loading } = this.state;
    const { className } = this.props;

    return (
      <section ref={this.ref} className={classnames('react-chemdraw--wrapper', className)}>
        {loading && (
          <div className="react-chemdraw--loading-loader">
            <span className="react-chemdraw--loading-text">Loading Editor</span>
            <Loader loaded={false} percentages={0} />
          </div>
        )}
      </section>
    );
  }
}

Chemdraw.defaultProp = {
  onLoaded: () => {},
  onChange: () => {},
};

Chemdraw.propTypes = {
  className: PropTypes.string,
  onChange: PropTypes.func,
  onLoaded: PropTypes.func,
};
